import { render, staticRenderFns } from "./GmbAttributes.vue?vue&type=template&id=18adb460&scoped=true&"
import script from "./GmbAttributes.vue?vue&type=script&lang=js&"
export * from "./GmbAttributes.vue?vue&type=script&lang=js&"
import style0 from "./GmbAttributes.vue?vue&type=style&index=0&id=18adb460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18adb460",
  null
  
)

export default component.exports